import { render, staticRenderFns } from "./dialogue.vue?vue&type=template&id=85d172aa&scoped=true&"
import script from "./dialogue.vue?vue&type=script&lang=js&"
export * from "./dialogue.vue?vue&type=script&lang=js&"
import style0 from "./dialogue.vue?vue&type=style&index=0&id=85d172aa&scoped=true&lang=scss&"
import style1 from "./dialogue.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85d172aa",
  null
  
)

export default component.exports